import SigninPage from '../pages/Signin';
import { Navigate, Route, Routes } from 'react-router-dom';
import JoinPage from 'src/pages/JoinPage';

export default function AuthRouter() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={`/`} replace />} />
      <Route path={'/'} element={<SigninPage />} />
      <Route path="/join/:email" element={<JoinPage />} />
    </Routes>
  );
}
